export { type ArtifactExportAssetDto } from '@inference.engine/api-client/web';

export enum ArtifactExportStatus {
  NOT_FOUND = 'not_found',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
}
